import React from 'react';
import { Section } from '@layout';
import RecentPost from './RecentPost';
import { Button, ButtonsWrapper } from '@input';
import styles from './News.module.scss';
import { useStaticQuery, graphql } from 'gatsby';

export default React.memo(function News() {
  const data = useStaticQuery(query);
  const edges = data?.allMarkdownRemark?.edges ?? [];
  const posts = edges
    .map(({ node }, index) => <RecentPost
      key={index}
      {...node}
    />)
    .filter(p => p);

  return (
    <Section className={styles.wrapper}>
      <h2>Lab updates</h2>
      <p>
        Read about what we’ve been up to lately and research we’ve recently
        published.
      </p>

      <div className={styles.posts}>
        {posts.length ? (
          posts
        ) : (
          <div className={styles.noPosts}>
            No recent updates, check again soon!
          </div>
        )}
      </div>

      <ButtonsWrapper>
        <Button
          icon="book"
          theme="white"
          to="/lab-updates"
        >
          Read more on our blog
        </Button>
      </ButtonsWrapper>
    </Section>
  );
});

const query = graphql`
  query RecentPostsQuery {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { templateKey: { eq: "BlogPost" } } }
      limit: 3
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          excerpt(pruneLength: 200)
          frontmatter {
            title
            templateKey
            date(formatString: "MMMM DD, YYYY")
            excerpt
            featuredimage {
              childImageSharp {
                desktop: fluid(quality: 80, maxWidth: 370) {
                  ...GatsbyImageSharpFluid_noBase64
                }

                mobile: fluid(quality: 80, maxWidth: 720) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
        }
      }
    }
  }
`;
